<template>
  <section>
  	<div class="total">
  			<div class="tit">选择日期</div>
  			<el-date-picker
		  		  class="datePick"
            v-model="dateVal"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="昨天"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          ></el-date-picker>
  		
  	</div>
  	<div class="content">
		  	<div class="tit">采集发行总体数据</div>
		  
 
		  	<el-button class="caiji"  type="primary" size="mini" @click="cjClick('get_issued_app_data')">采集</el-button>

		</div>
		
		<div class="content">
		  	<div class="tit">采集渠道分析数据</div>
		  	<div class="mainSelect" >
				 	<el-select v-model="chooseProduct.name" filterable  placeholder="请输入/选择小程序名称" >
					    <el-option
					      v-for="item in IssAppList"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id"
					      @click.native="changeProduct(item)"
					     
					      default-first-option
					    ></el-option>
				 	</el-select>
				 </div>
		  	<el-button class="caiji"  type="primary" size="mini" @click="cjClick('get_issued_app_ald_channel_retain_data')">采集</el-button>

		</div>
		
		<div class="content">
		  	<div class="tit">采集发行产品回本数据</div>
		  	<el-button class="caiji"  type="primary" size="mini" @click="cjClick('get_issued_app_cost_back')">采集</el-button>

		</div>
		
		<div class="content">
		  	<div class="tit">采集小花数据监控</div>
		  	<div class="mainSelect" >
				 	<el-select v-model="chooseProduct2.name" filterable  placeholder="请输入/选择小程序名称" >
					    <el-option
					      v-for="item in IssAppList"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id"
					      @click.native="changeProduct2(item)"
					     
					      default-first-option
					    ></el-option>
				 	</el-select>
				</div>
		  	<el-button class="caiji"  type="primary" size="mini" @click="cjClick('get_issued_monitor_data','now')">采集</el-button>
		</div>

   


		<el-dialog title="采集" :visible.sync="logDialog" width="890px">
      <el-table :data="plog" max-height="600">
        <!-- <el-table-column label="日期" :width="'150px'">111</el-table-column> -->
        <el-table-column prop="msg" label="采集记录" :width="'800px'"></el-table-column>
      </el-table>
    </el-dialog>
    <!--列表-->

  </section>
</template>

<script>
import { getPython,getIssuedAppList} from "../../api/api";

export default {
  data() {
    return {
      logDialog: false,
      pdata: {
        _sdate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        _edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        _date:new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        _app:'0',
        _token:'0',
        _channel:'0',
        type:'',
        _id:'0',
      },
       pdata2: {
        _sdate: new Date(new Date().getTime()).toISOString().slice(0, 10),
        _edate: new Date(new Date().getTime()).toISOString().slice(0, 10),
        _date:new Date(new Date().getTime()).toISOString().slice(0, 10),
        _app:'0',
        _token:'0',
        _channel:'0',
        type:'',
        _id:'0',
      },
      IssAppList:[],
      chooseProduct:{name:"",id:''},
      chooseProduct2:{name:"",id:''},
      plog:[],
      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      pickerOptions: {
      	  disabledDate(time) {
            return time.getTime() > Date.now()-1000*60*60*24;
          },

      },
      errorTime:0,
      


    }
  },
  watch: {
  	dateVal: {
      handler(n, o) {
        if (n[0]) {
          this.pdata._sdate = n[0];
          this.pdata._edate = n[1];
          this.pdata._date = n[0];

        }
      },
      deep: true
    }

  },
  methods: {
  	changeProduct(res){
	 	 this.pdata._id=res.id;
	 	 
	 },
	 changeProduct2(res){
	 	 this.pdata2._id=res.id;
	 },
  	getIssAPPList(){
			var p="";
			getIssuedAppList(p, this.$cookie.getCookie("login")).then(res => {
	        if (res.code == 200) {
	          this.IssAppList = res.data;
	          this.IssAppList.forEach((v,i)=>{
	          	if(v.id==this.pdata.issued_app_id ){
	          		this.chooseProduct.name=v.name;
	          	}
	          })
	        }
	      });
		},
    changeDate(s) {
      this.dateVal = "";
      this.pdata.sdate = new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10);
      this.pdata.edate = new Date(new Date().getTime() - 3600 * 1000 * 24 ).toISOString().slice(0, 10);
    },
    cjClick(type,now) {
    	
    	this.pdata._date =this.pdata._sdate;
			this.pdata.type=type;
			this.pdata._token='0';
			this.pdata._app="0";
      this.$confirm("确定需要采集吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
        
          this.logDialog=true;
          this.plog=[];
          if(now=='now'){
      		  this.pdata2._date =this.pdata2._sdate;
						this.pdata2.type=type;
						this.pdata2._token='0';
						this.pdata2._app="0";
						
			      this.diedai(this.pdata2);
    			}
          else{
          	this.diedai(this.pdata);
          }
          
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消采集"
          });
        });
    },
    diedai(d) {
      if (this.logDialog) {
      	var newPdata=d;
      	newPdata._sdate=newPdata._sdate.replace(/-/g,'');
      	newPdata._edate=newPdata._edate.replace(/-/g,'');
      	newPdata._date=newPdata._date.replace(/-/g,'');
	      var p = "";
	      for (var k in newPdata) {
	        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
	        if (newPdata[k]!=='') p += k + "=" + newPdata[k] + "&";
	      }
	      console.log(p);
	    
        getPython(p, this.$cookie.getCookie("login")).then(res => {
       		
          if (res) {
            if(res.finish!=undefined&&res.finish==1){
            		this.plog.unshift(res);
             		this.$message({ message: "数据采集完成", type: "success" });
             		this.errorTime=0;
            }
            else{
            	console.log(this)
           
        			this.plog.unshift(res);
        			
        			res.type=newPdata.type;
        			if(res._channel==undefined){
        				res._channel=newPdata._channel
        			}
        			
	   					newPdata=res;
	   					console.log(newPdata);
	            this.diedai(newPdata);
	            this.errorTime=0;
            }
            
      
          } 
          else {
          
          	if(this.errorTime>=5){
          		this.$alert('网络请求失败，请联系管理员', {
			          confirmButtonText: '知道了',
			        });
          	}
          	else{
          		setTimeout(()=>{
	          		this.diedai(newPdata);
	          	},10000);
	          	this.errorTime++;
          	}
          
          	
          	
            
          }
        });
      }
    }
  },

  mounted() {
  	this.getIssAPPList();
  }
};
</script>

<style lang="scss">
.el-button + .el-button {
  margin-left: 0;
}
#chart>div{
    margin: 0 auto;
}
</style>
<style scoped>


.tit{
	text-align: center;
	font-size: 14px;
	margin: 0 15px;
	width: 160px;
	text-align: right;
}
.caiji{
	width: 120px;
	margin: 0 15px;
}	
.datePick{
	vertical-align: middle;
}
.total{
    font-size: 20px;
    padding:10px 25px;
    line-height: 40px;
    margin: 20px auto;
    box-sizing: border-box;
    min-width: auto;
    display: flex;
    
}

.content{
	  font-size: 20px;
    padding:10px 25px;
    line-height: 40px;
    margin: 20px;
    box-sizing: border-box;
    min-width: auto;
    display: flex;
    border-bottom: 1px dashed #D3DCE6;
}

</style>





// WEBPACK FOOTER //
// list.vue?4fdba3aa